module.exports = __webpack_public_path__ + "static/pca-89425e4b57ec62ed3395ec539e3e1a0f.jpg";